import type {
  CampaignTemplateCustomStyle,
  ClubCampaignPrefectureGroup,
} from "@components/CampaignTemplate";
import CampaignTemplate from "@components/CampaignTemplate";
import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { isTypeProps, queryForSSP } from "@libs/apolloClient";
import { paths } from "@libs/paths";
import { Grampus202209_RawShopsDocument as RawShopsDocument } from "./__generated__/queries";
import styles from "./index.module.css";
import type { Grampus202209_RawShopsQueryResult as RawShopsQueryResult } from "./__generated__/queries";
import type { ApolloError } from "@apollo/client";
import type { GetServerSideProps, NextPage } from "next";

const isProduction = process.env.DEPLOY_ENV === "production";
const PREFECTURES: Array<ClubCampaignPrefectureGroup> = [
  {
    prefecture: "愛知",
    shopUuids: isProduction
      ? ["uQeyt1aNMolX", "DrTw2YvyFKBu", "lqOhxBuk7dyn", "1jgq0s4ZauLM"]
      : ["UuidUuidUuid", "UuidUuidUuid", "UuidUuidUuid", "UuidUuidUuid"],
  },
];

type Grampus202209PageProps = {
  data?: RawShopsQueryResult["data"];
  prefectures?: Array<ClubCampaignPrefectureGroup>;
  error?: ApolloError;
};

const Grampus202209: NextPage<Grampus202209PageProps> = ({
  data,
  prefectures,
}) => {
  return (
    <CommonLayout hasFooter noModal>
      <CommonHead
        title={
          "名古屋グランパスをお店で応援！名古屋グランパスを観戦できるスポーツバー"
        }
        description={
          "明治安田J1リーグの名古屋グランパス戦を応援できる梅田、心斎橋、阿倍野、住吉、恵比寿、八重洲などのDAZN公式契約スポーツバーをご紹介。応援ドリンクも販売中。スポーツバー探し、予約はFanstaで。"
        }
        ogUrl={paths.campaignGrampus202209}
        ogImage={`${process.env.APP_HOST}/img/campaign/grampus-202209/ogp.png`}
        canonicalUrl={paths.campaignGrampus202209}
      />
      <CampaignTemplate
        teamName="名古屋グランパス"
        slug="grampus-202209"
        leagueName="明治安田J1リーグ"
        teamIds={[20]}
        colorText="グランパスカラー"
        prefectures={prefectures}
        shopData={data?.rawShops}
        customStyle={styles as CampaignTemplateCustomStyle}
        sportGenreSlug={"soccer"}
        teamSlug={"grampus"}
        specialEventAreaHidden
        presentAreaHidden
      />
    </CommonLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  // PREFECTURESに定義されたデータからUUIDを抽出する。
  const shopUuids = PREFECTURES.map((p) => p.shopUuids);
  const flattenShopUuids = ([] as Array<string>).concat(...shopUuids);

  // 該当する店舗を検索する。
  const pageProps = await queryForSSP({
    query: RawShopsDocument,
    variables: {
      uuids: flattenShopUuids,
    },
  });

  if (!isTypeProps(pageProps)) {
    return {
      props: {},
    };
  }

  return {
    props: {
      ...pageProps.props,
      prefectures: PREFECTURES,
    },
  };
};

export default Grampus202209;
